// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"197":"4a227a78","450":"bba86677","560":"da624c28","773":"c10f1aa0"}[chunkId] + ".css";
};